import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TriggerCard from '__pages/AutomationEngine/Engine/Steps/TriggerCard';
import { FlowTrigger } from '../../types';
import { useHistory } from 'react-router-dom';
import { FlowBuilderContext } from '../../context';
import {
  PROPS_THAT_NEED_DEACTIVATION_ON_CHANGE,
  SMART_CONNECTOR_STEPS,
  SMARTCONNECTORS_PATHNAME,
} from '__pages/SmartConnectors/constants';
import { GenericOption } from 'pages/AutomationEngine/types';
import { getSmartConnectorTypeNames } from 'pages/SmartConnectors/helpers';

type TriggerStepSpreadsheetUploaded = {
  step: FlowTrigger;
  color: string;
};

export default function SpreadsheetUploadTriggerCard({
  step,
  color,
  ...others
}: TriggerStepSpreadsheetUploaded) {
  const { t } = useTranslation();
  const history = useHistory();

  const { smartConnector, flowErrors } = useContext(FlowBuilderContext);

  const hasErrors = PROPS_THAT_NEED_DEACTIVATION_ON_CHANGE.some(
    (prop) => prop in flowErrors
  );

  const menuOptions = useMemo(() => {
    return [
      {
        value: 'edit',
        label: t('Edit'),
      },
      smartConnector.source_file &&
        (!smartConnector.sql_enabled || smartConnector.live_script) && {
          value: 'variables',
          label: t('Initialize Variables'),
        },
    ].filter(Boolean);
  }, [
    t,
    smartConnector.source_file,
    smartConnector.sql_enabled,
    smartConnector.live_script,
  ]);

  const onSelectMenu = ({ value }: GenericOption) => {
    if (value === 'edit') {
      history.push(`${SMARTCONNECTORS_PATHNAME}/${smartConnector.id}`, {
        step: smartConnector.source_file
          ? SMART_CONNECTOR_STEPS.connection
          : SMART_CONNECTOR_STEPS.general,
      });
    }
    if (value === 'variables') {
      history.push(`${SMARTCONNECTORS_PATHNAME}/${smartConnector.id}`, {
        step: SMART_CONNECTOR_STEPS.variables,
      });
    }
  };

  return (
    <TriggerCard
      {...others}
      color={hasErrors ? 'var(--color-button-warning-hover)' : color}
      borderColor={hasErrors ? 'var(--color-button-warning-hover)' : null}
      editOnly={menuOptions.length === 1}
      onSelectMenu={onSelectMenu}
      menuOptions={menuOptions}
    >
      {getSmartConnectorTypeNames(t)[smartConnector.connector_type] ||
        smartConnector.connector_type}
    </TriggerCard>
  );
}
